<template>
  <div>
    <NuxtLink to="/k/jazda-bolidami" class="relative">
      <Img
        src="/f1.jpg"
        width="367"
        height="368"
        alt=""
      />
      <div class="absolute top-0 w-full h-full">
        <div class="w-4/5 bg-primary text-18 text-white mt-[50px] px-[15px] py-[5px]">
          Jazda bolidem
        </div>
      </div>
    </NuxtLink>
    <NuxtLink to="/k/jazda-supersamochodami" class="relative">
      <Img
        src="/jazda.jpg"
        width="367"
        height="368"
        alt=""
      />
      <div class="absolute top-0 w-full h-full">
        <div class="w-4/5 bg-primary text-18 text-white mt-[50px] px-[15px] py-[5px]">
          Jazda supersamochodem
        </div>
      </div>
    </NuxtLink>
    <NuxtLink to="/b/jazda-off-road-4x4" class="relative">
      <Img
        src="/offroad.jpg"
        width="367"
        height="368"
        alt=""
      />
      <div class="absolute top-0 w-full h-full">
        <div class="w-4/5 bg-primary text-18 text-white mt-[50px] px-[15px] py-[5px]">
          Jazda off road
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
